exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".url_url_3I3v0 {\r\n    font-family: monospace;\r\n    -webkit-user-select: text;\r\n       -moz-user-select: text;\r\n        -ms-user-select: text;\r\n            user-select: text;\r\n    word-wrap: break-word;\r\n}\r\n.url_url_3I3v0::before {\r\n    content: '\"';\r\n}\r\n.url_url_3I3v0::after {\r\n    content: '\"';\r\n}\r\n", ""]);

// exports
exports.locals = {
	"url": "url_url_3I3v0"
};